export default __webpack_public_path__ + "static/media/Senseye.af321b8b.png";